const SIZES = {
  md: 'h-7 w-7 text-xs',
  lg: 'h-10 w-10 text-base',
};

/**
 * Logo de marca en un tile parejo: `object-contain` con padding centra
 * cualquier proporción para que la lista quede ordenada. Sin logo → inicial.
 */
export default function BrandLogo({ name, logoUrl, size = 'md' }) {
  const dim = SIZES[size] ?? SIZES.md;
  if (logoUrl) {
    return (
      <span className={`inline-flex ${dim} shrink-0 items-center justify-center overflow-hidden rounded-lg border border-gray-200 bg-white p-1`}>
        <img src={logoUrl} alt="" className="max-h-full max-w-full object-contain" />
      </span>
    );
  }
  return (
    <span className={`inline-flex ${dim} shrink-0 items-center justify-center rounded-lg bg-gray-100 font-medium text-gray-500`}>
      {(name || '?').charAt(0).toUpperCase()}
    </span>
  );
}
